import { getAnomalyAccentColor } from '../../../../../shared/helpers/AnomalyIncidentHelpers';
import { GroupedAnomalyMarker } from './groupedAnomalyMarkers';

export type MarkerVisualState =
  | { mode: 'single'; accent: string }
  | { mode: 'mixed'; brandScoreAccent: string; averagePositionAccent: string };

export const resolveMarkerVisualState = (marker: GroupedAnomalyMarker): MarkerVisualState | null => {
  const { brandScore, averagePosition, visibility } = marker;
  const percentMetric = brandScore ?? visibility;

  if (!percentMetric && !averagePosition) {
    return null;
  }

  if (percentMetric && averagePosition) {
    if (percentMetric.direction === averagePosition.direction) {
      return { mode: 'single', accent: getAnomalyAccentColor(percentMetric.direction) };
    }

    return {
      mode: 'mixed',
      brandScoreAccent: getAnomalyAccentColor(percentMetric.direction),
      averagePositionAccent: getAnomalyAccentColor(averagePosition.direction),
    };
  }

  const incident = percentMetric ?? averagePosition;
  if (!incident) {
    return null;
  }

  return { mode: 'single', accent: getAnomalyAccentColor(incident.direction) };
};
